export const UserProfileRoutePath = '/myaccount/userprofile';
export const ChangePasswordRoutePath = '/myaccount/changepassword';
